<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>

    <span translate>COMMONS.CUSTOMERS_REGISTRY</span>
</div>

<tb-header specificTitle="COMMONS.CUSTOMERS_REGISTRY" parentPage="myusers"></tb-header>

<div class="contentGlobal" style="text-align: left">
    <ms-users-list></ms-users-list>
</div>
